<script lang="ts">
import type { LinkProps } from '$lib/types';
import LinkList from '../LinkList/LinkList.svelte';

interface Props {
    links?: LinkProps[];
    className?: string;
}

let { links = [], className = '' }: Props = $props();
</script>

<div class="blog-category-nav inpage-nav {className}">
    <LinkList items={links} />
</div>

<style lang="scss">
    @use '/src/scss/global-constants/fonts';
    @use '/src/scss/global-constants/typography';
    @use 'sass-mq/mq' as *;

    .blog-category-nav {
        padding: 0 var(--layout-pagegrid-margin) var(--layout-pagegrid-margin);
        padding-bottom: 3rem;
        padding-top: 3rem;
        overflow-x: scroll;
        overflow-y: hidden;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* Internet Explorer 10+ */
        @include mq($from: tablet) {
            padding-bottom: 5rem;
            padding-top: 5rem;
        }

        &::-webkit-scrollbar {
            display: none; /* Safari and Chrome */
        }

        :global(ul) {
            display: flex;
            gap: 2rem;
            justify-content: left;
            list-style: none;
            margin: 0;
            padding: 0;

            @include mq($from: tablet) {
                gap: 4rem;
            }
        }

        :global(a) {
            @include typography.nav-secondary;
            color: var(--colour-black-out);
            white-space: nowrap;
        }

        :global(a.active) {
            color: var(--colour-grey);
        }
    }
</style>
